export default function authenticate(state = [], action) {
	switch (action.type) {
	case 'AUTHENTICATE_USER':
		return {
			user: action.text,
		};
	default:
		return state;
	}
}
